import React, { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useChatQuery } from '../../hooks/useChatQuery';
import { useParams } from 'react-router-dom';
import { ChatMessagesList } from './ChatMessagesList';
import { ChatParticipantList } from './ChatParticipantList';
import { useUsersByIdListQuery } from '../../hooks/useUsersQuery';
import { getUserFioShort } from "../../helpers/users";
import { ChatActionButton } from "./ChatActionButton";
import { TravelClaimComplex, TravelClaimSimple, TravelClaimVise } from "../../types/travelClaims";
import { useChatContext } from "../../context/chats";
import { User } from "../../types/users";
import CardCollapseIcon from "../../assets/card_collapse.svg";
import CardRevealIcon from "../../assets/card_reveal.svg";

type ClaimsType = TravelClaimSimple | TravelClaimComplex | TravelClaimVise | any
type ChatProps = {
    claim: ClaimsType
}
export const ChatItem = ({ claim }: ChatProps) => {
    const { pk } = useParams();
    const queryClient = useQueryClient();

    const { chatUsers, updateChatUsers } = useChatContext();

    const [manager, setManager] = useState<User | null>(null)

    const {
        data: chat,
        isLoading: isLoadingChat,
        isSuccess: isSuccessChat
    } = useChatQuery(pk);

    const {
        data: users,
        isLoading: isLoadingUsers,
        isSuccess: isSuccessUsers
    } = useUsersByIdListQuery(chat?.participants);
    const {
        data: removedUsers,
    } = useUsersByIdListQuery(chat?.removed_participants);

    const invalidateChat = () => {
        setTimeout(() => {
            queryClient.invalidateQueries({
                queryKey: ['chat', pk],  // Чат запрашивается по ид заявки
                refetchType: 'all',
            });
        }, 1000)
    }

    const handleInvalidate = () => {
        queryClient.invalidateQueries({
            queryKey: ['travelClaim', pk],
            refetchType: 'all',
        });

        invalidateChat()
    }

    // Отслеживаем изменения назначенного менеджера
    useEffect(() => {
        const found = users && users.results.find(e => e.pk === claim?.responsible?.pk);
        setManager(found ?? null)

        // // Получаем кэш
        // const queryCache = queryClient.getQueryCache();
        // // Получаем активные очереди
        // const activeQueries = queryCache.getAll();
        // // Ключи очередей
        // const queryKeys = activeQueries.map((query) => query.queryKey);
        // console.log('QK UPDATED', queryKeys);

    }, [claim, users]);

    // Обновление контекста чата - загружаем пользователей в контекст
    useEffect(() => {
        updateChatUsers(users?.results || [])
    }, [users]);

    const isChatDisabled = claim?.service === 'TRIVIO' && ['EXCHANGED', 'CANCELLED', 'ISSUED'].includes(claim?.status);

    const [isCollapsedInfo, setIsCollapsedInfo] = useState(false);

    return (
        // ОБЩИЙ КОНТЕЙНЕР
        <div
            className="
                flex flex-col
                w-full flex-1 min-w-0 max-w-none
                h-full
                bg-white rounded-lg overflow-hidden
                items-stretch
                relative
            "
        >
            {/*СПИСОК УЧАСТНИКОВ*/}
            <div className={`${isCollapsedInfo ? 'hidden' : 'block'}`}>
                <ChatParticipantList
                    claim_type={claim?.type}
                    participants={users ? users.results : []}
                    chat_pk={chat?.pk}
                    comment={claim?.responsible_comment}
                    trip_id={pk}
                />
            </div>

            <div className="flex flex-[1_0_auto]"></div>
            {/*КОНТЕЙНЕР СООБЩЕНИЙ*/}
            {chat && pk && <ChatMessagesList
                trip_id={pk}
                chat_pk={chat.pk}
                claimPk={claim?.pk}
                invalidate={handleInvalidate}
                disabled={isChatDisabled}
                users={users && removedUsers ? [...users.results, ...removedUsers.results] : []} />
            }
            {/*ИНФА И КНОПКИ ПО ЗАЯВКЕ*/}
            <div className='absolute top-20 w-full h-32'>
                <div className={`${isCollapsedInfo ? 'hidden' : 'block'}`}>
                    <div
                        className="
                            flex
                            flex-row
                            justify-between
                            items-center
                            bg-white
                            rounded-lg
                            shadow-shadow-card
                            m-5 py-4 px-5
                            h-22
                        "
                    >
                        <div className='leading-4 flex flex-col gap-1 place-content-evenly'>
                            <div>
                                Заявка №{pk}
                            </div>
                            <div className='text-melon-grey-darker'>
                                {/*Назначен тревел-менеджер {chat.travel_manager}*/}
                                {manager && `Назначен тревел-менеджер ${getUserFioShort(manager)}`}
                            </div>
                        </div>
                        {chat && <ChatActionButton
                            chat_pk={chat.pk}
                            chat_status={chat.status}
                            claim_pk={pk || ''}
                            claim_status={claim?.status}
                            // onTravelManagerAssigned={invalidateChat}
                            onComplete={invalidateChat}
                            onRequested={invalidateChat}
                        />}
                    </div>
                </div>

                <div className="mt-3 flex justify-end">
                    <button
                        type="button"
                        onClick={() => setIsCollapsedInfo(v => !v)}
                        className="
                                mx-5
                                rounded-lg
                                bg-melon-light
                                h-10
                                w-10
                            "
                    >
                        <img
                            className='inline-block cursor-pointer'
                            src={isCollapsedInfo ? CardCollapseIcon : CardRevealIcon}
                            alt=''
                        />
                    </button>
                </div>
            </div>
        </div>
    );
};
